import setFullbanner from './home/1_fullbanner';
import setIconsVertical from './home/icons_vertical';
import setBrandsCarousel from './home/brands_carousel';
import setCarousel from '../components/carousel';
import CategoryTabs from './home/3_category_tabs';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsVertical();
		setBrandsCarousel();
		setCarousel();
		CategoryTabs.init();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
